// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : viewer parts
// =============================================================================
// ---Third-party imports
import React, {useState, useEffect} from 'react'
import {Menu, Dropdown, Icon, Segment} from 'semantic-ui-react'
import {ReflexContainer, ReflexSplitter, ReflexElement} from 'react-reflex'

// ---Framework imports
import {Sel} from 'uix/registries'
import {Part, funcPart} from 'uix/parts'
import log from 'uix/logging'
import {GlobalMenu, DebugFeature} from 'uix/components'
import {useSelector} from 'uix/hooks'
import {decodeSlimLink} from 'uix/utils'
import {TitleList} from 'uix/frontend/components'

// ---Local imports
import {Viewer, goTreeViewer} from './components'

// ---Globals
export const ViewerTitleList = ({go}) => (
  <TitleList onSelectTitle={title => goTreeViewer(go, title)} />
)

let decodeOtid = id => decodeSlimLink(id).otid || id

export class ViewerGrid extends Part {
  static className = 'attached'

  static uiDefaults = {
    multi: false,
    multiRows: false,
    multiCols: false,
    __version__: 2,
  }

  renderMulti(columns, rows) {
    let {imageLocs, request} = this.props

    let Pane = ({col, row}) => (
      <div className="reflexPane">
        <Viewer vid={`${col}${row}`} imageLocs={imageLocs} otid={decodeOtid(request.id)} />
      </div>
    )

    let Columns = ({row}) => {
      if (columns == 1) {
        return <Pane col="0" row={row} />
      }
      return (
        <ReflexContainer
          orientation="vertical"
          className={`reflexColumns count${columns} row${row}`}
        >
          <ReflexElement>
            <Pane col="0" row={row} />
          </ReflexElement>
          <ReflexSplitter />
          <ReflexElement>
            <Pane col="1" row={row} />
          </ReflexElement>
        </ReflexContainer>
      )
    }

    if (rows == 1) {
      return <Columns row="0" />
    } else {
      return (
        <ReflexContainer orientation="horizontal" className={`reflexRows count${rows}`}>
          <ReflexElement>
            <Columns row="0" />
          </ReflexElement>
          <ReflexSplitter />
          <ReflexElement>
            <Columns row="1" />
          </ReflexElement>
        </ReflexContainer>
      )
    }
  }

  _render() {
    let {imageLocs, request, ui, setUI} = this.props
    let columns = ui.multiCols ? 2 : 1
    let rows = ui.multiRows ? 2 : 1
    //~ if (!imageLocs) {
    //~ return 'no imagelocs'
    //~ }
    //~ let style = {}
    return (
      <>
        <DebugFeature>
          <GlobalMenu>
            <Menu.Item content="Mordor" style={{fontWeight: 'bold'}} />
            <Menu.Item
              active={ui.multiRows}
              onClick={() => setUI({multiRows: !ui.multiRows})}
              icon="list layout"
            />
            <Menu.Item
              active={ui.multiCols}
              onClick={() => setUI({multiCols: !ui.multiCols})}
              icon="columns"
            />
          </GlobalMenu>
        </DebugFeature>
        {columns > 1 || rows > 1 ? (
          this.renderMulti(columns, rows)
        ) : (
          <Viewer vid="0" imageLocs={imageLocs} otid={decodeOtid(request.id)} />
        )}
      </>
    )
  }
}

export {I3FDetails} from './i3f'
